function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "45",
  height: "45"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Group_4053",
  "data-name": "Group 4053",
  transform: "translate(-1008 -243)",
  fill: "#72b22e"
}, /*#__PURE__*/React.createElement("path", {
  id: "Ellipse_23",
  "data-name": "Ellipse 23",
  d: "M22.5 2.5a20.006 20.006 0 00-7.784 38.429A20.006 20.006 0 0030.284 4.071 19.872 19.872 0 0022.5 2.5m0-2.5A22.5 22.5 0 110 22.5 22.5 22.5 0 0122.5 0z",
  transform: "translate(1008 243)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1595",
  "data-name": "Path 1595",
  d: "M-5513.971-14497.152l-9.442-9.442 2.828-2.828 6.614 6.614 14.509-14.509 2.828 2.828z",
  transform: "translate(6540.523 14773.509)"
}))));